import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { devolucionesApi } from '../api/devoluciones';
import { toast } from 'sonner';

export function useDevoluciones(params?: any) {
  return useQuery({
    queryKey: ['devoluciones', params],
    queryFn: () => devolucionesApi.getAll(params),
    staleTime: 1000 * 60 * 2,
  });
}

export function useDevolucion(id: number) {
  return useQuery({
    queryKey: ['devoluciones', id],
    queryFn: () => devolucionesApi.getById(id),
    enabled: !!id && id > 0,
    staleTime: 1000 * 60 * 2,
  });
}

export function useDevolucionStats() {
  return useQuery({
    queryKey: ['devoluciones', 'stats'],
    queryFn: () => devolucionesApi.getStats(),
    staleTime: 1000 * 60 * 5,
  });
}

export function useCreateDevolucion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => devolucionesApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devoluciones'] });
      toast.success('Devolución creada exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al crear la devolución');
    },
  });
}

export function useUpdateDevolucion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      devolucionesApi.update(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['devoluciones'] });
      queryClient.invalidateQueries({ queryKey: ['devoluciones', id] });
      toast.success('Devolución actualizada exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al actualizar la devolución');
    },
  });
}

export function useDeleteDevolucion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => devolucionesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devoluciones'] });
      toast.success('Devolución eliminada exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al eliminar la devolución');
    },
  });
}